/* eslint-disable no-unused-vars */
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import getParameters from '@app/libs/getParameters'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function ReportIndex({ data, total, campaignSearchList }) {
  const { t, i18n } = useTranslation()
  const { url } = usePage()
  const urlObj = new URL(url, location.origin)
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          childrenTableName={t('VOUCHERS.LIST_VOUCHERS')}
          collapseColumns={[
            {
              id: 'name',
              Header: t('VOUCHERS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'total_points',
              Header: t('VOUCHER.POINTS'),
              accessor: 'total_points',
              type: 'number',
            },
            {
              id: 'quantity',
              Header: t('VOUCHER.QUANTITY'),
              accessor: 'quantity',
              type: 'number',
            },
            {
              id: 'amount_codes',
              Header: t('VOUCHER.AMOUNT_CODES'),
              accessor: 'amount_codes',
              type: 'number',
            },
            {
              id: 'price',
              Header: t('VOUCHER.PRICE'),
              accessor: 'price',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'type',
              Header: t('VOUCHER.VOUCHER_TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
            },
            {
              id: 'total',
              Header: t('VOUCHERS.TOTAL'),
              accessor: 'total',
              type: 'number',
            },
          ]}
          columns={[
            {
              id: 'campaign_name',
              Header: t('CAMPAIGNS.NAME'),
              accessor: 'campaign_name',
              type: 'multiSelect',
              options: campaignSearchList,
              router: 'partner.report.costReport',
              only: 'campaignSearchList',
            },
            {
              id: 'date',
              Header: t('CAMPAIGN.TIME'),
              accessor: 'start_at',
              type: 'dateRange',
              isVisible: false,
              disableSortBy: true,
            },
            {
              id: 'time',
              Header: t('CAMPAIGN.TIME'),
              accessor: ({ start_at, end_at }) => ({ start_at, end_at }),
              type: 'datePeriod',
              disableFilters: true,
              disableSortBy: true,
            },
            {
              id: 'total_voucher',
              Header: t('CAMPAIGNS.TOTAL_VOUCHERS'),
              accessor: 'total_voucher',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
            {
              id: 'total_cost',
              Header: t('CAMPAIGNS.TOTAL_COST'),
              accessor: 'total_cost',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
          ]}
          data={data}
          enableCollapseFilter={false}
          exportable={{
            enableExport: true,
            url: 'partner.report.cost.export',
            params: { ...getParameters(urlObj), locale: i18n.language },
          }}
          routeName="partner.report.costReport"
          total={total}
        />
      </Grid>
    </Grid>
  )
}
